import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { createContext, useEffect, useState } from "react";
import { ThemeProvider as StyledComponentsProvider } from "styled-components";
import getColorScheme from "./getColorScheme";
import { lightTheme } from "../styles/lightTheme";
import { darkTheme } from "../styles/darkTheme";
import { defaultTheme } from "../styles/defaultTheme";
import { jsx as _jsx } from "react/jsx-runtime";
var systemColorScheme = getColorScheme();
export var ThemeContext = /*#__PURE__*/createContext({
  colorScheme: systemColorScheme,
  setColorScheme: function setColorScheme() {
    return undefined;
  }
});
var colorSchemeKey = (process.env.REACT_APP_NAME ? process.env.REACT_APP_NAME + "-" : "") + "color-scheme";
export default function ThemeProvider(_ref) {
  var theme = _ref.theme,
      _ref$lightTheme = _ref.lightTheme,
      light = _ref$lightTheme === void 0 ? lightTheme : _ref$lightTheme,
      _ref$darkTheme = _ref.darkTheme,
      dark = _ref$darkTheme === void 0 ? darkTheme : _ref$darkTheme,
      children = _ref.children;
  var storageScheme = localStorage.getItem(colorSchemeKey);

  var _useState = useState(storageScheme || systemColorScheme),
      _useState2 = _slicedToArray(_useState, 2),
      colorScheme = _useState2[0],
      setColorScheme = _useState2[1];

  var usedTheme = theme || (colorScheme === "dark" ? dark : light) || defaultTheme;

  var changeColorScheme = function changeColorScheme(colorScheme) {
    localStorage.setItem(colorSchemeKey, colorScheme);
    setColorScheme(colorScheme);
  };

  var handleColorSchemeChange = function handleColorSchemeChange(event) {
    if (event.matches) {
      setColorScheme("dark");
    } else {
      setColorScheme("light");
    }
  };

  useEffect(function () {
    document.documentElement.style.backgroundColor = usedTheme.palette.background;
    document.documentElement.style.color = usedTheme.palette.text;
    document.documentElement.style.colorScheme = usedTheme.palette.mode; //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colorScheme]);
  useEffect(function () {
    if (!storageScheme) {
      window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", handleColorSchemeChange);
      return function () {
        window.matchMedia("(prefers-color-scheme: dark)").removeEventListener("change", handleColorSchemeChange);
      };
    } //eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return /*#__PURE__*/_jsx(ThemeContext.Provider, {
    value: {
      colorScheme: colorScheme,
      setColorScheme: changeColorScheme
    },
    children: /*#__PURE__*/_jsx(StyledComponentsProvider, {
      theme: usedTheme,
      children: children
    })
  });
}